// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__b8V8-","wrapper":"Footer_wrapper__lozXd","list":"Footer_list__l2wdG","logo":"Footer_logo__THE-l","social":"Footer_social__l24E1","copy":"Footer_copy__pYELr"};